import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const UserBioRoutes = defineRoute({
    detail: {
        route: {
            path: "/user-attendance/:id",
            component: () => loadView(import("./UserBioHome.vue")),
        },
        build(id: string) {
            return `/user-attendance/${id}`;
        },
    },
});
